// Minimal GA4 event helper.
//
// Why a wrapper instead of calling window.gtag directly:
//   • Gracefully no-ops when the user hasn't consented to analytics
//     (gtag is never loaded in that case — calls would throw).
//   • Gracefully no-ops in dev where REACT_APP_GA_ID is unset.
//   • Gives us a single place to sanitise parameters, standardise
//     snake_case event names, and add prefixes if we ever move to GA4
//     custom events.
//
// Usage:
//   import { trackEvent } from '@/lib/analytics';
//   trackEvent('apply_click', { location: 'hero' });

export function trackEvent(name, params = {}) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  // GA4 accepts only snake_case event names; allow callers to pass
  // anything, but defensively convert "apply-click" / "applyClick".
  const safe = name.replace(/[-\s]/g, '_').replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
  try {
    window.gtag('event', safe, params);
  } catch {
    // Never break the page because analytics failed.
  }
}

/** Convenience for tel: / mailto: / WhatsApp / Apply clicks where we
 *  want a 1-liner rather than an onClick handler closure. */
export function onExternalClick(eventName, params) {
  return () => trackEvent(eventName, params);
}
